export const stringMapDefault = {
    toggleMenu: "Toggle Menu"
};
